import {
  Container,
  Paper,
  Typography,
  Box,
  ThemeProvider,
  createTheme
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings';
import { GLOBAL_LABELS } from '@/shared/constants/ui/app.constants';

// Creamos un tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f5f5f5',
    },
  },
})

export default function MaintenancePage() {
  /* const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, []) */

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',

          //bgcolor: '#D2E0FB' FC2B0C 
        }}
      >
        <Container maxWidth="sm">
          <Paper elevation={0} sx={{ p: 4, textAlign: 'center', borderRadius: '5px' }}>
            <Box mb={3}>
              <img
                src="https://fibramax.ec/wp-content/uploads/2021/01/LOGORGB.png"
                alt="Logo de la empresa"
                style={{ width: '100%' }}
              />
            </Box>
            <Typography variant="h4" component="h1" gutterBottom>
              {GLOBAL_LABELS.APP_TITLE} en Mantenimiento
            </Typography>

            <Typography variant="h6" gutterBottom>
              Estamos realizando mejoras. Volveremos pronto.
            </Typography>

            <SettingsIcon
              sx={{
                fontSize: 60,
                color: 'primary.main',
                animation: 'spin 10s linear infinite',
                '@keyframes spin': {
                  '0%': {
                    transform: 'rotate(0deg)',
                  },
                  '100%': {
                    transform: 'rotate(360deg)',
                  },
                },
                mb: 2
              }}
            />

            {/* <Typography variant="subtitle1">
              Hora actual: {currentTime.toLocaleTimeString()}
            </Typography> */}
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  )
}